<app-title-section></app-title-section>

<div class="card p-1"  style="margin-left: 15px; margin-right: 15px; min-height:100vh;">

    <ul class="nav nav-tabs m-0 " style=" border-bottom: 1px solid #eee;">
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/vente/bon-sortie/tous']" [class.active]="currentStatus === 'tous'" (click)="filterByStatus('tous')">
                    Tous <span *ngIf="currentStatus === 'tous'">({{ getStatusCount('Tous') }})</span>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/vente/bon-sortie/brouillon']" [class.active]="currentStatus === 'brouillon'" (click)="filterByStatus('brouillon')">
                    Brouillon <span *ngIf="currentStatus === 'brouillon'">({{ getStatusCount('Brouillon') }})</span>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/vente/bon-sortie/cree']" [class.active]="currentStatus === 'cree'" (click)="filterByStatus('cree')">
                    Créé <span *ngIf="currentStatus === 'cree'">({{ getStatusCount('Créé') }})</span>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/vente/bon-sortie/annule']" [class.active]="currentStatus === 'annule'" (click)="filterByStatus('annule')">
                    Annulé <span *ngIf="currentStatus === 'annule'">({{ getStatusCount('Annulé') }})</span>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/vente/bon-sortie/livre']" [class.active]="currentStatus === 'ferme'" (click)="filterByStatus('ferme')">
                    Fermé <span *ngIf="currentStatus === 'ferme'">({{ getStatusCount('Fermé') }})</span>
                </a>
            </li>
        </ul>
        <div class="container-fluid" style="padding: 0; width: 100%; max-width: 100%;">
            <router-outlet></router-outlet>
        </div>
    </div>

